import { useState } from 'react'

import { History, Eye } from '../../assets/icons'
import CustomTooltip from './CustomTooltip'

const HistoryBox = ({ time, progress, numberOfEntries, onRestoreClick, inputsData, type = 'document', description, editableStatus }) => {
  const [showBody, setShowBody] = useState(false)

  let content = (
    <div className="history-box-v2">
      <header>
        <div className='history-box-v2__dot' />
        <div className="history-box-v2__time">{time}</div>
        <div className="history-box-v2__progress">
          <p className="main">Progression: {(progress * 100).toFixed(0)}%</p>
          {/* <div className="progress-bar"><div style={{width: `${progress * 100}%`}}></div></div> */}
          <p className="number-of-entries">{numberOfEntries} données saisies</p>
          {(editableStatus && editableStatus !== 'none') && <p className={`editable-status ${editableStatus === 'activated' ? 'success' : 'error'}`}>{editableStatus === 'activated' ? 'Edition activée' : 'Edition desactivée'}</p>}
        </div>
        <div className="history-box-v2__actions">
          <CustomTooltip content="Restaurer la version" placement="top">
            <button className="icon-btn icon-btn--border-light icon-btn--squircle mr-2 icon-btn--sm" onClick={onRestoreClick}><History /></button>
          </CustomTooltip>
          <button className="btn btn--with-icon btn--xs btn--primary-light btn--border-radius-sm" onClick={() => setShowBody(!showBody)}><Eye /> Aperçu</button>
        </div>
      </header>
      {showBody && 
        <div className="history-box-v2__body">
          {inputsData.map((item, index) => {
            return (
              <div className="group" key={index}>
                <p className="label">{item.label}</p>
                <p className="input">{Array.isArray(item.input) ? null : item.input}</p>
              </div>
            )
          })}
        </div>
      }
    </div>
  )

  if(type === 'template') {
    content = (
      <div className="history-box-v2 history-box-v2--template">
        <header>
          <div className='history-box-v2__dot' />
          <div className="history-box-v2__time">{time}</div>
          <div className="history-box-v2__progress">
            <p className="main">{description}</p>
          </div>
        </header>
      </div>
    )
  }

  return content
}

export default HistoryBox